/**
 * @generated SignedSource<<74a64f6b2367849a396f840d4ad3298c>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "User_user",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserNameLabel_user"
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
};
node.hash = "8378a421705d8aef558e67e8e1637bcf";
export default node;
